import React from 'react'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DataCollectionSF from '../../../components/superUser/loan/DataCollectionSF'

const DataCollectionPageUI = ({ context, errorList, loan, onRefreshClick,
  copyToClipboardText, onCopyToClipboard, onAccountUpdate

}) =>
  <SuperUserPageSF context={context} className='pg_su_loan_a_lst' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='dataCollection'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <DataCollectionSF context={context} loan={loan} onRefreshClick={onRefreshClick}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onAccountUpdate={onAccountUpdate}
      />
    }
  </SuperUserPageSF>

export default DataCollectionPageUI
